//import css
import "./scss/main.scss";
//import 'swiper/swiper-bundle.css';

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./assets/', true, /\.(gif|png|svg|ico|jpe?g)$/i));

import "svgxuse";
//AOS

import 'aos/dist/aos.css';



require("./js/lazyload")
require("./js/vh-mobile")
import * as modules0 from "./components/alerts/alerts.js"; import * as modules1 from "./components/button/button.js"; import * as modules2 from "./components/chi-siamo/chi-siamo.js"; import * as modules3 from "./components/come-fare/come-fare.js"; import * as modules4 from "./components/cta-block/cta-block.js"; import * as modules5 from "./components/events/events.js"; import * as modules6 from "./components/foglia-corpo/foglia-corpo.js"; import * as modules7 from "./components/foglia-dati/foglia-dati.js"; import * as modules8 from "./components/foglia-hero-image/foglia-hero-image.js"; import * as modules9 from "./components/foglia-hero/foglia-hero.js"; import * as modules10 from "./components/foglia-news/foglia-news.js"; import * as modules11 from "./components/footer/footer.js"; import * as modules12 from "./components/header/header.js"; import * as modules13 from "./components/hero/hero.js"; import * as modules14 from "./components/img-loader/img-loader.js"; import * as modules15 from "./components/img-responsive/img-responsive.js"; import * as modules16 from "./components/loader/loader.js"; import * as modules17 from "./components/news/news.js"; import * as modules18 from "./components/section/section.js"; var modules = [modules0, modules1, modules2, modules3, modules4, modules5, modules6, modules7, modules8, modules9, modules10, modules11, modules12, modules13, modules14, modules15, modules16, modules17, modules18];



$( document ).ready(function() {
	
});